export function fallbackCopy(texto) {
  const textarea = document.createElement("textarea");
  textarea.value = texto;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  textarea.style.top = "-9999px";

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();

  const ok = document.execCommand("copy");
  document.body.removeChild(textarea);
  return ok;
}

export async function copiarTexto(texto) {
  try {
    // Clipboard API só funciona bem em HTTPS / localhost
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      await navigator.clipboard.writeText(texto);
      return true;
    }
    return fallbackCopy(texto);
  } catch {
    return fallbackCopy(texto);
  }
}
